import { getBase64fromUrl } from "./getBase64FromUrl";
import md5 from "md5";
import api from "@/store/api";

export const usePdfHTML = async (data) => {
  // Await Images
  const loEmailImage =
    process.env.VUE_APP_IMAGE_URL +
    md5(data.lo.imageEmail.toLowerCase()) +
    "/135/Email";
  const loImageSrc = await getBase64fromUrl(loEmailImage);

  let showReserved = "";
  if (data.partner.title.value) {
    showReserved =
      data.partner.title.value === "REALTOR" ? "inline-block" : "none";
  }

  const ruoffImage = require("@/assets/images/logo-horizontal-color-nmls.png");
  // Filter Licenses
  const filterLicenses = () => {
    const filteredArray = [];
    data.lo.licenses.forEach((license) => {
      if (
        (license.State === "AZ") |
        (license.State === "GA") |
        (license.State === "KY") |
        (license.State === "OH")
      ) {
        filteredArray.push(license);
      }
    });
    return filteredArray;
  };

  // Build License Template
  const filteredLicenses = filterLicenses();
  let license0;
  let license1;
  let license2;
  let license3;
  if (filteredLicenses[0])
    license0 = `<span>${filteredLicenses[0].State}: ${filteredLicenses[0].LicenseNumber}</span>`;
  if (filteredLicenses[1])
    license1 = `<span> | ${filteredLicenses[1].State}: ${filteredLicenses[1].LicenseNumber}</span>`;
  if (filteredLicenses[2])
    license2 = `<span>${filteredLicenses[2].State}: ${filteredLicenses[2].LicenseNumber}</span>`;
  if (filteredLicenses[3])
    license3 = `<span> | ${filteredLicenses[3].State}: ${filteredLicenses[3].LicenseNumber}</span>`;

  function isCoBranded() {
    return data.partner.email &&
      data.partner.companyLogo &&
      data.partner.fullName &&
      data.partner.photo &&
      data.partner.title &&
      data.partner.phoneNumber
      ? true
      : false;
  }

  // Create New Element From PDF Template
  const element = document.createElement("div");
  element.style.fontFamily = "Helvetica";
  if (isCoBranded()) {
    element.innerHTML = `
      <div
        style="
          max-width: 900px;
          padding: 8px;
          margin-top: 16px;
          display: flex;
          justify-content: space-around;
          line-spacing: 1;
          line-height: 1.1;
          font-size: 14px;
        "
      >
            <div
          style="
            display: flex;
            gap: 8px;
            align-items: center;
            justify-content: center;
          "
        >
          <div>
            <img
              src="${loImageSrc}"
              style="width: inherit; height: inherit; object-fit: contain"
            />
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
            "
          >
            <img
              src="${ruoffImage}"
              style="
                width: inherit;
                height: inherit;
                object-fit: contain;
                max-height: 50px;
                max-width: 100px;
              "
              alt="Ruoff Logo"
            />
            <strong style="">${data.lo.firstName} ${data.lo.lastName}</strong>
            <span>${data.lo.title}</span>
            <span>NMLS: ${data.lo.nmls}</span>
            <div style="display: grid">
              <div style="flex">
                ${filteredLicenses[0] ? license0 : ""}${
      filteredLicenses[1] ? license1 : ""
    }
              </div>
              <div style="flex">
                ${filteredLicenses[2] ? license2 : ""}${
      filteredLicenses[3] ? license3 : ""
    }
              </div>
            </div>
            <strong style="">${data.lo.phone}</strong>
            <span style="text-transform: lowercase">${data.lo.imageEmail}</span>
          </div>
        </div>
        <div
          style="
            display: flex;
            gap: 8px;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            style="
              position: relative;
              overflow: hidden;
              border-radius: 100%;
              height: 135px;
              width: 135px;
              background-color: #16af8c;
              object-fit: cover;
            "
          >
            <img
              src="${data.partner.photoUrl}"
              alt="Image"
              style="
                position: absolute;
                top: 36%;
                left: 36%;
                transform: translate(-35%, -35%);
                min-width: 135px;
                min-height: 135px;
                max-width: 210px;
                max-height: 210px;
              "
            />
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              height: 100%;
              gap: 2px;
            "
          >
            <div style="background-color: white; width: fit-content;">
              <img
                src="${data.partner.companyLogoUrl}"
                style="max-height: 45px; max-width: 100px"
              />
            </div>
            <strong style="">${data.partner.fullName}</strong>
            <span>${
              data.partner.title.value
            }<sup style="font-size:9px; display: ${showReserved}">&reg<sup></span>
            <strong style="">${data.partner.phoneNumber}</strong>
            <span style="text-transform: lowercase"
              >${data.partner.email}</span
            >
          </div>
        </div>
      </div>
          `;
  } else {
    element.innerHTML = `
    <div style="max-width: 900px; padding: 8px; margin-top: 16px; display: flex; justify-content: space-around; line-spacing: 1; line-height: 1.1; font-size: 14px;">
      <div style="display: flex; gap: 8px; align-items: center; justify-content: center">
        <div>
          <img src="${loImageSrc}" style="width: inherit; height: inherit; object-fit: contain">
        </div>
        <div style="display: flex; flex-direction: column; justify-content: flex-end;">
          <span style="">${data.lo.firstName} ${data.lo.lastName}</span>
          <span>${data.lo.title}</span>
          <span>NMLS: ${data.lo.nmls}</span>
          <div style="display: grid">
            <div style="flex">
            ${filteredLicenses[0] ? license0 : ""}${
      filteredLicenses[1] ? license1 : ""
    }
            </div>
            <div style="flex">
            ${filteredLicenses[2] ? license2 : ""}${
      filteredLicenses[3] ? license3 : ""
    }
            </div>
          </div>
          <span style="">${data.lo.phone}</span>
          <span style="text-transform: lowercase;">${data.lo.imageEmail}</span>
        </div>
      </div>
      <div style="display: grid">
        <div style="width: 211px; height: 81px;">
          <img src="${
            data.logo
          }" style="width: inherit; height: inherit; object-fit: contain">
        </div>
        <div style="display: grid">
          <p style="font-weight: 900; text-transform: uppercase; letter-spacing: -0.75px;"><span>Apply online at </span><span style="color: rgb(19 138 114);">Ruoff.com${
            data.lo.applyUrl
          }</span></p>
          <span>${data.company.address}</span>
          <span>O: ${data.company.phone} | F: ${data.company.fax}</span>
        </div>
      </div>
    </div>
  `;
  }

  return element;
};
